import { ListFilter } from "lucide-react";
import React, { FC, MouseEvent, useState } from "react";

import { Grid, Menu, MenuItem } from "@mui/material";

import { IgButton } from "./IgButton";
import { IgCheckbox } from "./IgCheckbox";

interface IgTableFilterButtonProps {
  filterTitle: string;
  activeFilters: string[];
  options: string[];
  onFilterClick: (key: string) => void;
}

export const IgTableFilterButton = ({
  filterTitle,
  options,
  activeFilters,
  onFilterClick,
}: IgTableFilterButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLElement>, key: string) => {
    onFilterClick(key);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IgButton
        onClick={(event) => {
          setAnchorEl(event.currentTarget);
        }}
        startIcon={<ListFilter size={16} />}
        variant={"outlined"}
        sx={{ fontWeight: 400 }}
      >
        {filterTitle}
      </IgButton>
      <Menu
        id="ig-table-filter-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {options.map((option) => (
          <MenuItem
            value={option}
            key={option}
            onClick={(event) => {
              handleClick(event, option);
            }}
          >
            <IgCheckbox
              size={"small"}
              checked={activeFilters.includes(option)}
            />

            {option}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
